export type HexColor = `#${string}`;

export type Col =
  | string
  | HexColor
  | { hex: HexColor };

export function normalizeToHex(col: Col): HexColor {
  if (typeof col === 'string' && col.startsWith('#')) {
    return col as HexColor;
  }

  // @ts-expect-error
  return col.hex;
}
